var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 53,
    viewBox: "0 0 57 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5804 43.8246C23.8606 44.3621 26.2253 44.618 28.6744 44.618C37.8797 44.618 46.1279 40.7025 51.758 34.5093C55.6991 30.1843 55.6991 23.5049 51.758 19.2055C51.3076 18.6937 50.8009 18.2074 50.2942 17.7212",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58813 34.5108C7.84019 36.9676 10.5145 39.0661 13.4704 40.704L43.9014 13.0138C39.4254 10.5058 34.2456 9.09828 28.6718 9.09828C19.4665 9.09828 11.2183 13.0138 5.58813 19.207C1.64702 23.5064 1.64702 30.2114 5.58813 34.5108Z",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0023 26.8539C20.0023 29.0292 20.9875 30.9998 22.5358 32.4329L34.8096 21.2749C33.2613 19.8418 31.0655 18.9717 28.6727 18.9717C23.8589 18.9717 20.0023 22.4777 20.0023 26.8539Z",
    fill: "#F0F2FA",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7139 3.1817L43.904 13.0089L34.8113 21.275L22.5375 32.4329L13.4448 40.699L2.63489 50.5262",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7139 3.1817L43.904 13.0089L34.8113 21.275L22.5375 32.4329L13.4448 40.699L2.63489 50.5262",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/Eye-Off.e52d21922576e654f9b619b6475a8bad.svg";
export { ForwardRef as ReactComponent };